'use client';

import { useEffect, useRef, useState } from 'react';

import { CloseIcon, SearchIcon } from '@/components/icons';
import { InputAdornment, TextField, type TextFieldProps } from '@/primitives';

export interface SearchBarProps {
  onChange?: (value: string) => void;
  placeholder?: string;
  sx?: TextFieldProps['sx'];
}

export function SearchBar({ onChange, placeholder, sx }: SearchBarProps) {
  const [inputValue, setInputValue] = useState('');
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleChange: TextFieldProps['onChange'] = (event) => {
    const value = event.target.value;
    setInputValue(value);
    if (onChange) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        onChange(value);
        timeoutRef.current = null;
      }, 300);
    }
  };

  const handleClearInput = () => {
    setInputValue('');
    if (onChange) {
      onChange('');
    }
  };

  return (
    <TextField
      value={inputValue}
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment sx={{ padding: '0 10px' }} position="end">
            <CloseIcon onClick={handleClearInput} sx={{ cursor: 'pointer' }} />
          </InputAdornment>
        ),
        sx: {
          borderRadius: '28px !important',
        },
      }}
      hiddenLabel
      variant="filled"
      placeholder={placeholder}
      sx={{
        width: '600px',
        ...sx,
      }}
    />
  );
}
